module.exports = __webpack_public_path__ + "img/translate-three.c1722fd3.png";